import { atom } from 'recoil'

export const modalContentsDefaultsState = atom({
  key: 'messageModalContentsDefaultsState',
  default: {
    show: false
  }
})
